import { render, staticRenderFns } from "./TicketInfoBody.vue?vue&type=template&id=48aa613a&"
import script from "./TicketInfoBody.vue?vue&type=script&lang=ts&"
export * from "./TicketInfoBody.vue?vue&type=script&lang=ts&"
import style0 from "./TicketInfoBody.vue?vue&type=style&index=0&id=48aa613a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports